import { ChangeDetectorRef, Component, ElementRef, OnInit, ViewChild, ViewRef } from '@angular/core';
import { SidebarCommon } from '../../../@core/common/sidebar';
import { UserModel, BusinessModel } from '../../../@models';
import { ApiService } from '../../../@core/service/api.service';
import { Subscription } from 'rxjs';
import { IssuerData, ImporterData, OfferStatusData,
  DateSelectionData, CountryCodes, 
  FiscalYearData,
  UnitData,
  DatesData} from '../../../@models/erp/compilationData';
import { BusinessUnitModel } from '../../../@models/businessUnit';
import { ActivatedRoute, Router } from '@angular/router';
import { FinishedProductModel, NameTable } from '../../../@models/erp/finishedProduct';
import { ReportsPrinterComponent } from './reports-printer/reports-printer.component';
import { AuthGuardService } from '../../../@core/service/auth-guard.service';
import { SelectorDisplayMode } from '../document/document-select/document-select.component';
import { getDocumentNumber, mongoId, waitForVariable } from '../../../@core/common/global';
import { CompilationModel } from '../../../@models/erp/compilation';
import { SharedDataService } from '../../../@core/service/shared-data.service';
import * as moment from 'moment';
import * as saveAs from 'file-saver';
import { defaultReport, getReportOverviewFields } from './report-overview-fields';

@Component({
  selector: 'ngx-reports',
  templateUrl: './reports.component.html',
  styleUrls: ['./reports.component.scss'],
})
export class ReportsComponent extends SidebarCommon<ReportsComponent> implements OnInit {

  searchorder = 1;

  selectorDisplayMode = SelectorDisplayMode;

  fiscalYearOptions = [{ id: '', name: ''}, ...FiscalYearData.getOptions()];


  static defaultReport = defaultReport;

  report = { ...defaultReport }; // copy

  search: any; // one of report.xxxx

  subscriptions: Subscription[] = [];

  // users: UserModel[];
  // userOptions: { id: string, name: string }[];
  userContactOptions: { id: string, name: string }[];

  businesses: BusinessModel[];
  businessOptions: { id: string, name: string }[];
  businessOptionsMulti: { id: string, name: string }[];
  placeOfLoadingOptions:  { id: string, name: string }[];
  // finishedProductNames: NameTable[];

  customerRefData: {code: string, customerReference: string, customerDocumentNumber: string}[];
  customerNameOptions: { id: string, name: string }[];
  customerDocOptions: { id: string, name: string }[];
  customerDocOptionsMulti: { id: string, name: string }[];

  businessUnits: BusinessUnitModel[];
  businessUnitOptions: { id: string, name: string }[];
  businessUnitOptionsMulti: { id: string, name: string }[];

  baseProductOptionsMulti: { id: string, name: string }[];
  finishedProductOptionsMulti: { id: string, name: string }[];

  issuerOptions = [{id: null, name: '---- All ----'}, ...IssuerData.getOptions()];
  importerOptions = ImporterData.getOptions();
  countryOptions = [{id: null, name: '---- All ----'}, ...CountryCodes.getOptions()];
  unitOptions = UnitData.getOptions().filter(f => f.id !== 3) as any;

  ocOptions: {id: string, name: string}[]
  csOptions: {id: string, name: string}[]
  dnOptions: {id: string, name: string}[]

  dateSelectionOptions = DateSelectionData.getOptions();

  datesData = DatesData;

  meansOfTransportOptions: {id: string, name: string}[];

  documentNumberOptions: { id: string, name: string }[];

  offerStatusOptions = [{id: null, name: '---- All ----'}, ...OfferStatusData.getOptions()];
  offerStati = [{id: null, name: 'undefined'}, ...OfferStatusData.getStati()];

  finishedProduct: FinishedProductModel;

  baseProductOptions = [];

  pdfSidebar = false;

  nameOverride = '';

  reportType: string = '';

  reportPreset: any = {};
  reportPresetOptions: any = {};
  jsonParams: any = {}


  @ViewChild('reportsPrinterComp') reportsPrinterRef: ReportsPrinterComponent;
  @ViewChild('OSPO', {static: true}) ospoRef: ElementRef;
  @ViewChild('NIOC', {static: true}) niocRef: ElementRef;

  constructor(
    private api: ApiService,
    public data: SharedDataService,
    private route: ActivatedRoute,
    private cdRef: ChangeDetectorRef,
    public auth: AuthGuardService,
    private router: Router
  ) {

    super();

    this.report.offers.offerStatus = this.offerStati.map((m, idx) =>
      this.report.offers.offerStatus[idx] = true
    );

    this.report.deliverynotes = Object.assign({}, this.report.noninvoiced);

    this.report.projectoverview = Object.assign({}, this.report.noninvoiced);
    this.report.projectoverview.filterCompletedProjects = true;
    this.report.projectoverview.projectOverview = true;
    this.report.projectoverview.sortDate = 'expectedNextInvoiceDate';

    this.report.inventory = JSON.parse(JSON.stringify(this.report.boxes));
  }

  async ngOnInit() {
  
    const query = this.route.snapshot.queryParams;
    if (query.report) this.openReport(query);

    console.log('query params', query);

    this.api.getOcOptions().then(opts =>
      this.ocOptions = [{ id: null, name: '---- All ----'}, ...opts]
    );
    this.api.getDnOptions().then(opts =>
      this.dnOptions = [{ id: null, name: '---- All ----'}, ...opts]
    );
    this.api.getCsOptions().then(opts => {
      this.csOptions = opts.map(m => ({ id: m.code, name: getDocumentNumber(m) })) // [{ id: null, name: '---- All ----'}, ...opts]
    }
    );
    const s1 = this.data.loadUsers().then(_users => {
      this.userContactOptions =
        [{ id: null, name: '---- All ----'}, ..._users.map(c => ({ id: c.contact && c.contact._id, name: c.name }))
          .sort((a, b) => (a.name < b.name) ? -1 : 1)];
    });
    this.data.loadBusinessUnits().then(async _units => {
      this.businessUnits = _units;
      this.businessUnitOptionsMulti = _units.map(item => ({ id: item._id, name: item.name }))
        .filter((val, idx, self) => self.indexOf(val) === idx);
      this.businessUnitOptions = [{ id: null, name: '---- All ----'}, ...this.businessUnitOptionsMulti];

      this.report.deliverynotes.filterInternal = true;
      this.report.deliverynotes.businessUnits = [_units.find(f => f.code === 'EM')._id];
      this.report.deliverynotes.sampleRequest = 3;
      this.report.deliverynotes.showRelatedPFSPOs = true;
      this.report.deliverynotes.noPrices = true;
      this.report.deliverynotes.sortType = 1;
      this.report.deliverynotes.documentNumbers = [];
      this.report.deliverynotes.invoiceStatus = 0;  // 0 = Default, 1 = All, 2 = Not invoiced, 3 = Invoiced 
    })
    this.api.getCustomerReferenceData().then(refs => {
      // console.log('refs', refs)
      this.customerRefData = refs;
      // this.customerRefData = refs;
      // this.customerNameOptions = [{ id: null, name: '---- All ----'},
      //   ...refs.map(item => ({ id: item.name, name: item.name }))
      //     .filter(f => f.id)];
      this.customerRefChanged(null);
    });

    this.api.getCompilationData().then(stores =>
      this.meansOfTransportOptions = [{ id: null, name: '---- All ----'},
        ...stores.meansOfTransportStore.map(m => ({id: m, name: m}))]
    );
    this.api.getDocumentNumbers([4,6,12,13], [2]).then(docs => {  // SPO, PFSPO, SPC, PFSPC && status = final
      this.documentNumberOptions = [{ id: null, name: '---- All ----'},
        ...docs.map(m => ({id: m.code, name: m.code + 'VS' + m.version}))]
    });

    this.data.loadProducts().then(() => {
      this.baseProductOptions = [{ id: undefined, name: '---- All ---- | ---- All ---- | ---- All ----'},
        ...this.data.baseProducts?.map(bp => ({ id: bp._id, name: `${bp.code} | [${bp.trial}] | ${bp.name}` }))
      ];
      this.baseProductOptionsMulti = this.data.baseProductOptions;
      this.finishedProductOptionsMulti = this.data.finishedProductOptions;
    })

    for (const i in this.report) {
      if (this.report[i].dateType) {
        this.dateSelectionChanged(this.report[i], this.report[i].dateType);
      }
    }

    this.data.loadBusinesses().then(_businesses => {
      this.businesses = _businesses;
      this.businessOptionsMulti = _businesses.map(item => ({ id: item._id, name: item.name + (item.active ? '' : ` (Deactivated)`) }))
        .filter((val, idx, self) => self.indexOf(val) === idx);
      this.businessOptions = [{ id: null, name: '---- All ----'}, ...this.businessOptionsMulti];
      const b = this.data.business;
      this.placeOfLoadingOptions = [b.ceva, b.nrt, b.nrka, b.nrkv, b.nrvi, b.jerich, ...this.data.businesses].map(m => ({ id: m._id, name: m.name }));
      // this.report.inventory.placeOfLoading = mongoId(_businesses.find(b => /Jerich/.test(b.name)));
      this.report.inventory.stockStatus.onStock = true;
      this.report.inventory.orientation = 'landscape';
    });

    await this.data.loadCompilationData();
    console.log('compilation data loaded', JSON.stringify(query));
    // for (const presetType of this.data.compilationData.reportPresetsStore) {
    //   this.reportPresetOptions[presetType.id] = [{ id: null, name: 'Default'}, ...presetType.data.map(m => ({id: m.id, name: m.id}))];
    //   this.reportPreset[presetType.id] = null;
    // }
    for (const presetType in this.report) {
      const item = this.data.compilationData.reportPresetsStore?.find(f => f.id === presetType);
      this.reportPresetOptions[presetType] = [{ id: null, name: 'Default'}, ...(item?.data?.map(m => ({id: m.id, name: m.id})) || [])];
      this.reportPreset[presetType] = null;
    }

    if (this.cdRef && !(this.cdRef as ViewRef).destroyed) this.cdRef.detectChanges();

    if (query.reportsmailer) {
      // console.log('compilation data loaded2', query.reportsmailer, query);
      this.report.customeroverview.sortByManager = true;
      this.quickLink(0);
      // console.log('compilation data loaded3', query.reportsmailer, this.report);

      if (query.frombackend) {
        const mailerData = this.data.compilationData[query.reportsmailer]
        const item = mailerData?.find(f => f.id === 'mailtext');
        // console.log('compilation data loaded4', query.reportsmailer, query.frombackend, mailerData);

        if (item) {
          item.data = [];
          // console.log('reports mail from backend', query.reportsmailer, mailerData, item.data);
          await this.api.saveCompilationData(query.reportsmailer, mailerData);
        }
      }
    }

  }

  addPreset(report, type) {
    let reportData = this.data.compilationData.reportPresetsStore.find(f => f.id === type);
    if (!reportData) {
      reportData = { id: type, name: type, data: [] };
      this.data.compilationData.reportPresetsStore.push(reportData);
    }
    const entry = reportData.data.find(f => f.id === this.reportPreset[type]);
    if (entry) {
      entry.params = JSON.stringify(report);
    } else {
      reportData.data.push({ id: this.reportPreset[type], params: JSON.stringify(report)});   
    }
    this.reportPresetOptions[type] = [{ id: null, name: 'Default'}, ...reportData.data.map(m => ({id: m.id, name: m.id}))];
    this.api.saveCompilationData('reportPresetsStore', this.data.compilationData.reportPresetsStore);
  }

  removePreset(report, type) {
    const reportData = this.data.compilationData.reportPresetsStore.find(f => f.id === type);
    const idx = reportData.data.findIndex(f => f.id === this.reportPreset[type]);
    reportData.data.splice(idx, 1);
    this.reportPresetOptions[type] = [{ id: null, name: 'Default'}, ...reportData.data.map(m => ({id: m.id, name: m.id}))];
    this.api.saveCompilationData('reportPresetsStore', this.data.compilationData.reportPresetsStore);
    this.reportPreset[type] = null;
  }

  presetChanged(type, presetId) {
    if (!presetId) {
      this.report[type] = { ...defaultReport[type] };
    } else {
      const reportData = this.data.compilationData.reportPresetsStore.find(f => f.id === type);
      const preset = reportData.data.find(f => f.id === presetId);
      console.log('preset loaded >>> ', this.report[type], JSON.parse(preset.params));
      this.report[type] = JSON.parse(preset.params);
      if (!this.report[type].manager) this.report[type].manager = null // fix for legacy presets w/o manager
    }
    if (this.report[type].dateType !== DateSelectionData.all.id || this.report[type].dateType !== DateSelectionData.custom.id) {
      this.dateSelectionChanged(this.report[type], this.report[type].dateType);
    }
  }

  orderChanged(order) {
    this.report.orders.orderNumberVersioned = this.ocOptions.find(f => f.id === order).name;
  }

  addCombinedShipment(cs: CompilationModel, shipments: any) {
    shipments.push(cs);
  }

  shallExpand(id: string) {
    const item = this.route.snapshot.queryParams['id'];
    return id === item;
  }
  collapsedChange(id: string) {
    if (id === 'CO') {
      // TODO: scroll to bottom
    }
  }

  openReport(query: any) {
    this.jsonParams = JSON.parse(this.route.snapshot.queryParams?.params || '{}');
    switch (query.report) {
      case 'openspo':
        this.report.openspo = { ...this.report.openspo, ...JSON.parse(query.params) };
        waitForVariable(this.ospoRef).then(avail => {
          if (avail) {
            const el = this.ospoRef.nativeElement;
            el && el.scrollIntoView({ block: 'center' });
          }
        })
        break;
      case 'noninvoiced':
        this.report.noninvoiced = { ...this.report.noninvoiced, ...JSON.parse(query.params) };
        waitForVariable(this.niocRef).then(avail => {
          if (avail) {
            const el = this.niocRef.nativeElement;
            el && el.scrollIntoView({ block: 'center' });
          }
        })
    }
  }

  onTogglePrinter(type, report, hidden = false, variant = 0) {
    const search = {};
    this.reportType = type;
    search[type] = report;
    search[type].nameOverride = this.nameOverride;

    // console.log('-------------------> onTogglePrinter', type, variant, hidden);

    if (variant === 1) {
      search[type] = {
        ...search[type],
        dateFrom: moment(new Date()).subtract(2, 'months').toDate(),
        dateTo: new Date(),
        sortByManager: true,
        sampleRequest: 3, // no SR
        filename:`${moment().format('YYMMDD')}_OF`,
      }
    } else if ([401, 402].includes(variant)) {
      search['noninvoiced'] = {
        ...search[type],
        dateFrom: search[type].dateFrom || -1,
        dateTo: search[type].dateTo || -1,
        sortByManager: variant === 401,
        sampleRequest: 3, // no SR
        projectOverview: true,
        filterCompletedProjects: true,
        showRelatedPFSPOs: true,
        showInvoicedOCs: true,
        businessUnits: this.data.businessUnits.filter(f => ['AM', 'FX', 'MM', 'BA', 'VI'].includes(f.code)).map(m => m._id)
      }
      if (type !== 'noninvoiced') delete search[type];
    }
    // if (variant > 0) {
    //   search[type] = {
    //     ...search[type],
    //     variant: variant,
    //   }
    // }
    this.search = search;
    // console.log('onTogglePrinter', type, report, search);
    if (!hidden) {
      this.pdfSidebar = true;
      this.toggleSidebar(this);
    }
    // this.reportsPrinterRef.search = this.search;
    // this.reportsPrinterRef.reloadData();
    this.reportsPrinterRef.loading = false;
  }

  onToggleExcel(type, report, hidden = false, extended = undefined/*, inventory = false*/) {
    if (report === this.report.inventoryMonthly) {
      report = this.report.inventoryMonthly = JSON.parse(JSON.stringify(this.report.inventory));
    }
    //if (this.route.snapshot.queryParams.fromBackend) 
    const search = {};
    this.reportType = report;
    search[type] = report;
    this.search = search;
    search[type].nameOverride = this.nameOverride;
    if (extended) search[type].extended = extended;
    search[type].fromBackend = true;
    // if (extended === 4) {

    // console.log('-------------------> onToggleExcel', type, hidden);

      
    //   search[type].projectOverview = true;
    // }
    // search[type].inventory = inventory;
    // if (inventory) {
    //   search[type].stockStatus = { notInInventory: false, onStock: true, shipped: false };
    // }
    if (extended === 6) {
      search[type].businessUnits = this.data.businessUnits.filter(f => ['AM', 'FX', 'MM', 'BA', 'VI'].includes(f.code)).map(m => m._id);
      search[type].showRelatedPFSPOs = true;
      search[type].showInvoicedOCs = true;
    }
    if (!hidden) {
      this.pdfSidebar = false;
      this.toggleSidebar(this);
    }
  }

  public save(/* item: ReportsComponent */) {
    throw new Error('Method not implemented.');
  }
  public cancel(/* item: ReportsComponent */) {
    throw new Error('Method not implemented.');
  }

  dateSelectionChanged(type: any, id: number, date = new Date()) {
    // console.log('dateSelectionChanged', type, id, date)
    type.dateType = +id;

    if (+id === DateSelectionData.custom.id) return;

    type.dateFrom = type.dateTo = new Date(date);
    switch (+id) {
      case DateSelectionData.thisCalendarWeek.id:
        while (type.dateFrom.getDay() !== 1) {
          type.dateFrom = new Date(type.dateFrom.setDate(type.dateFrom.getDate() - 1));
        }
        type.dateTo = new Date(type.dateFrom);
        type.dateTo = new Date(type.dateTo.setDate(type.dateFrom.getDate() + 6));
        break;
      case DateSelectionData.lastCalendarWeek.id:
        while (type.dateTo.getDay() !== 0) {
          type.dateTo = new Date(type.dateTo.setDate(type.dateTo.getDate() - 1));
        }
        type.dateFrom = new Date(type.dateTo);
        type.dateFrom = new Date(type.dateFrom.setDate(type.dateFrom.getDate() - 6));
        break;
      case DateSelectionData.nextCalendarWeek.id:
        while (type.dateFrom.getDay() !== 0) {
          type.dateFrom = new Date(type.dateFrom.setDate(type.dateFrom.getDate() + 1));
        }
        type.dateFrom = new Date(type.dateFrom.setDate(type.dateFrom.getDate() + 1));
        type.dateTo = new Date(type.dateFrom);
        type.dateTo = new Date(type.dateTo.setDate(type.dateFrom.getDate() + 6));
        break;
      case DateSelectionData.currentMonth.id:
        type.dateFrom = new Date(type.dateFrom.getFullYear(), type.dateFrom.getMonth(), 1);
        type.dateTo = new Date();
        break;
      case DateSelectionData.lastMonth.id:
        type.dateFrom = new Date(type.dateFrom.getFullYear(), type.dateFrom.getMonth() - 1, 1);
        type.dateTo = new Date(type.dateTo.getFullYear(), type.dateTo.getMonth(), 0);
        break;
      case DateSelectionData.currentYear.id:
        type.dateFrom = new Date(type.dateFrom.getFullYear(), 0, 1);
        type.dateTo = new Date(type.dateTo.getFullYear(), 11, 31);
        break;
      case DateSelectionData.currentFiscalYear.id:
        if (new Date() < new Date(type.dateFrom.getFullYear(), 9, 1)) {
          type.dateFrom = new Date(type.dateFrom.getFullYear()-1, 9, 1);
          type.dateTo = new Date(type.dateTo.getFullYear(), 8, 30);
        } else {
          type.dateFrom = new Date(type.dateFrom.getFullYear(), 9, 1);
          type.dateTo = new Date(type.dateTo.getFullYear()+1, 8, 30);
        }
        break;
      case DateSelectionData.yearToDate.id:
        type.dateFrom = new Date(type.dateFrom.getFullYear(), 0, 1);
        type.dateTo = new Date();
        break;
      case DateSelectionData.lastYear365.id:
        type.dateFrom = new Date(type.dateFrom.setDate(type.dateFrom.getDate() - 365));
        type.dateTo = new Date();
        break;
      case DateSelectionData.lastCalendarYear.id:
        type.dateFrom = new Date(type.dateFrom.getFullYear() - 1, 0, 1);
        type.dateTo = new Date(type.dateTo.getFullYear() - 1, 11, 31);
        break;
      case DateSelectionData.lastFiscalYear.id:
        if (new Date() < new Date(type.dateFrom.getFullYear(), 9, 1)) {
          type.dateFrom = new Date(type.dateFrom.getFullYear()-2, 9, 1);
          type.dateTo = new Date(type.dateTo.getFullYear()-1, 8, 30);
        } else {
          type.dateFrom = new Date(type.dateFrom.getFullYear()-1, 9, 1);
          type.dateTo = new Date(type.dateTo.getFullYear(), 8, 30);
        }
        break;
      case DateSelectionData.nextYear365.id:
        type.dateFrom = new Date();
        type.dateTo = new Date(type.dateTo.setDate(type.dateTo.getDate() + 365));
        break;
      case DateSelectionData.nextFiscalYear.id:
        if (new Date() < new Date(type.dateFrom.getFullYear(), 9, 1)) {
          type.dateFrom = new Date(type.dateFrom.getFullYear(), 9, 1);
          type.dateTo = new Date(type.dateTo.getFullYear()+1, 8, 30);
        } else {
          type.dateFrom = new Date(type.dateFrom.getFullYear()+1, 9, 1);
          type.dateTo = new Date(type.dateTo.getFullYear()+2, 8, 30);
        }
        break;
      case DateSelectionData.past365TillNextMonth.id:
        type.dateTo = new Date(type.dateTo.getFullYear(), type.dateTo.getMonth() + 1, type.dateTo.getDate());
        type.dateFrom = new Date(type.dateFrom.setDate(type.dateFrom.getDate() - 365));
        return;
      case DateSelectionData.past365ToNext365.id:
        type.dateFrom = new Date(type.dateFrom.setDate(type.dateFrom.getDate() - 365));
        type.dateTo = new Date(type.dateTo.setDate(type.dateTo.getDate() + 730));
        break;
      case DateSelectionData.past30ToNext365.id:
        type.dateFrom = new Date(type.dateFrom.setDate(type.dateFrom.getDate() - 30));
        type.dateTo = new Date(type.dateTo.setDate(type.dateTo.getDate() + 395));
        break;
      case DateSelectionData.allTillToday.id:
        type.dateFrom = new Date(2016, 0, 1);
        type.dateTo = new Date();
        break;
      case DateSelectionData.allTillNextWeek.id:
        while (type.dateTo.getDay() !== 1) {
          type.dateTo = new Date(type.dateTo.setDate(type.dateTo.getDate() + 1));
        }
        type.dateTo = new Date(type.dateTo.setDate(type.dateTo.getDate() + 6));
        type.dateFrom = new Date(2016, 0, 1);
        break;
      case DateSelectionData.allPlus30.id:
        type.dateFrom = new Date(2016, 0, 1);
        type.dateTo = new Date(type.dateTo.setDate(type.dateTo.getDate() + 30));
        break;
      case DateSelectionData.all.id:
        type.dateFrom = -1;
        type.dateTo = -1;
        break;
    }

  }

  customerRefChanged(businessId: string) {
    let ret = [];
    if (businessId) {
      ret = this.customerRefData.filter(f => f.customerReference === businessId).map(m => m.customerDocumentNumber)
    } else {
      ret = this.customerRefData.map(m => m.customerDocumentNumber)
    }
    this.customerDocOptionsMulti = ret.sort((a, b) => a.localeCompare(b))
      .filter((item, pos, self) => self.indexOf(item) === pos)  // unique doc nums
      .map(m => ({id: m, name: m}));
    this.customerDocOptions = [{ id: null, name: '---- All ----'}, ...this.customerDocOptionsMulti];
  }

  async generateWeeklyReports(businessString = null) {
    if (businessString) {
      await this.generateReport('openspo', true, false, {
        sortType: 6, // customer reference
        sampleRequest: 3, // no SR
        customers: [this.data.businesses.find(f => new RegExp(businessString).test(f.name))?._id],
        dateField: 1,
        dateFrom: null,
        dateTo: null,
      })
    } else {
      for (const pdf of ['offers', 'orders', 'noninvoiced', 'lastinvoices', 'dueinvoices']) {
        await this.generateReport(pdf);
      }
    }
  }

  async generateReport(type: string, pdf = true, defaults = false, searchOverride = {} as any) {
    this.reportsPrinterRef.loading = true;
    this.reportsPrinterRef.pdfSidebar = pdf;

    console.log('generateReport', type, pdf, defaults, searchOverride);
    if (searchOverride.withEnRoute) { searchOverride.filename = searchOverride.filename.replace('09', '12') + '_With_En_Route' }
    
    searchOverride.fromBackend = this.route.snapshot.queryParams?.frombackend === 'true';

    const report = {};
    report[type] = defaults ? JSON.parse(JSON.stringify(defaultReport[type])) : Object.assign({},this.report[type]);
    Object.assign(report[type], searchOverride);
    this.reportsPrinterRef.search = report;

    console.log('params and override', this.reportsPrinterRef.search, searchOverride, this.reportsPrinterRef.search);

    if (pdf) {
      this.onTogglePrinter(type, report[type], true);
      await this.reportsPrinterRef.reloadData(true);
      await (this.reportsPrinterRef.downloadPdf(type));
    } else {
      this.onToggleExcel(type, report[type], true);
      await this.reportsPrinterRef.reloadData(true);
      await (this.reportsPrinterRef.downloadExcel(type));
    }
  }

  public static getCWReportNamesForReportsMailer() {
    const getFilename = (num, name, sr = false) => {
      if (num === 4) {
        name += '_EM';
      } else if ([401].includes(num)) {
        name += '_Machinery';
      } else {
        name += '_All';
      }
      return num < 10 
          ? `${moment().format('YY')}CW${moment().format('WW')}_0${num}_${name}${sr ? '_SR' : ''}`
          : `${moment().format('YYMM')}_0${num}_${name}${sr ? '_SR' : ''}`
    }

    return [
        { id: 1, header: 'Last Invoices', name: getFilename(1, 'Last invoices') },
        { id: 2, header: 'Due Invoices', name: getFilename(2, 'Due invoices') },
        { id: 3, header: 'Orders', name: getFilename(3, 'Orders') },
        { id: 4, header: 'OC EM', name: getFilename(4, 'OC') },
        { id: 401, header: 'OC Machinery', name: getFilename(401, 'OC') },
        { id: 5, header: 'OF', name: getFilename(5, 'OF') },
        { id: 6, header: 'Last Invoices (SR)', name: getFilename(6, 'Last invoices', true) },
        { id: 7, header: 'Orders(SR)', name: getFilename(7, 'Orders', true) },
        { id: 8, header: 'OC (SR)', name: getFilename(8, 'OC', true) },
        { id: 9, header: 'Inventory', name: getFilename(9, 'Inventory') },
        { id: 10, header: 'Sales', name: getFilename(10, 'Sales') + '.pdf' },
        { id: 11, header: 'Planned Activities', name: getFilename(11, 'PlannedActivities') + '.pdf' },
        { id: 12, header: 'Inventory (En Route)', name: getFilename(12, 'Inventory_EnRoute') },
    ]
  }

  public static getCWReportNamesForReportsMailer2() {
    const getFilename = (num, name, sr = false) => 
      num < 10 
          ? `${moment().format('YY')}CW${moment().format('WW')}_0${num}_${name}`
          : `${moment().format('YYMM')}CW${moment().format('WW')}_${num}_${name}`

    return [
      { id: 1, header: 'Activity Overview', name: getFilename(1, 'ActivityOverview') + '.pdf' },
      { id: 2, header: 'Offers', name: getFilename(2, 'OF') + '.pdf' },
      { id: 3, header: 'Offers (EXCEL)', name: getFilename(3, 'OF') + '.xlsx' },
      { id: 421, header: 'SR Report', name: '' },
    ]
  }

  public static getCWReportNamesForReportsMailerHQ() {
    const getFilename = (num, name, sr = false) => 
      num < 10 
          ? `${moment().format('YYMM')}_0${num}_${name}`
          : `${moment().format('YYMM')}_${num}_${name}`

    return [
      { id: 1, header: 'Due Invoices', name: getFilename(1, 'Due Invoices') + '.pdf' },
      { id: 401, header: 'OC Machinery', name: getFilename(2, 'OC') + '.pdf' },
      { id: 411, header: 'OC Machinery (EXCEL)', name: getFilename(3, 'OC') + '.xlsx' },
      // { id: 421, header: 'SR Report', name: '' },
      { id: 201, header: 'Payment Report', name: '' },
      { id: 431, header: 'Track SPO Payment', name: '' },
    ]
  }

  async quickLink(link: number) {

    const reports = this.route.snapshot.queryParams?.reports?.split(',').map(m => +m) || [1,2,201,3,4,401,402,411,421,5,6,7,8,9,10,11];

    // console.log('++++++++reports', reports);

    let buNames = ['All']
    if (!this.report.customeroverview.buFilter.all) {
      const bu: string[] = [];
      buNames = [];
      if (this.report.customeroverview.buFilter.machinery) {
        buNames.push('Machinery');
        bu.push('VI', 'MM', 'BA');
      }
      if (this.report.customeroverview.buFilter.energy) {
        buNames.push('Energy')
        bu.push('EM');
      }
      if (this.report.customeroverview.buFilter.composite) {
        buNames.push('Composites');
        bu.push('CO');
      }
      this.report.customeroverview.businessUnits = bu.map(m => this.data.businessUnits.find(f => f.code === m)._id);
    }

    const defaults = {
      sortByManager: this.report.customeroverview.sortByManager,
      businessUnits: this.report.customeroverview.businessUnits,
      reportsmailer: this.route.snapshot.queryParams.reportsmailer,
    }

    if (!defaults.reportsmailer || defaults.reportsmailer === 'reportsMail') {

      if (reports.includes(1)) await this.generateReport('lastinvoices', true, true, {
        ...defaults,
        ...getReportOverviewFields('lastinvoices', link, buNames),
        reportNum: 1,
      });

      if (reports.includes(2)) await this.generateReport('dueinvoices', true, true, {
        ...defaults,
        ...getReportOverviewFields('dueinvoices', link, buNames),
        reportNum: 2,
      });
      
      if (reports.includes(3)) await this.generateReport('orders', true, true, {
        ...defaults,
        ...getReportOverviewFields('orders', link, buNames),
        reportNum: 3,
      });
      
      if (reports.includes(4)) await this.generateReport('noninvoiced', true, true, {
        ...defaults,
        ...getReportOverviewFields('noninvoiced', link, buNames, { reportNum: 4}),
        businessUnits: ['EM'].map(m => this.data.businessUnits.find(f => f.code === m)._id),
        reportNum: 4,
      });

      if (reports.includes(401)) await this.generateReport('noninvoiced', true, true, {
        ...defaults,
        ...getReportOverviewFields('noninvoiced', link, buNames, { reportNum: 401}),
        businessUnits: ['VI', 'BA', 'MM', 'AM', 'FX'].map(m => this.data.businessUnits.find(f => f.code === m)._id),
        projectOverview: true,
        filterCompletedProjects: true,
        showRelatedPFSPOs: true,
        showInvoicedOCs: true,
        filterInternal: true,
        sortByManager: true,
        dateFrom: -1,
        dateTo: -1,
        sortType: 4,
        sortDate: 'expectedNextInvoiceDate',
        reportNum: 401,
      });
      
      if (reports.includes(5)) await this.generateReport('offers', true, true, {
        ...defaults,
        ...getReportOverviewFields('offers', link, buNames),
        reportNum: 5,
      });

      if (reports.includes(6)) await this.generateReport('lastinvoices', true, true, {
        ...defaults,
        ...getReportOverviewFields('lastinvoices_sr', link, buNames),
        reportNum: 6,
      });

      if (reports.includes(7)) await this.generateReport('orders', true, true, {
        ...defaults,
        ...getReportOverviewFields('orders_sr', link, buNames),
        reportNum: 7,
      });

      if (reports.includes(8)) await this.generateReport('noninvoiced', true, true, {
        ...defaults,
        ...getReportOverviewFields('noninvoiced_sr', link, buNames),
        reportNum: 8,
      });
      
      if (reports.includes(9)) await this.generateReport('boxes', false, true, {
        ...defaults,
        ...getReportOverviewFields('boxes', link, buNames),
        reportNum: 9,
      });

      const filter = getReportOverviewFields('salesreport', link, buNames, this.data) as any;

      if (reports.includes(10)) this.api.downloadSalesReport(filter).subscribe(data => {
        saveAs(data, filter.filename);
      });

      const filter2 = getReportOverviewFields('plannedreport', link, buNames, this.data) as any;

      if (reports.includes(11)) this.api.downloadSalesReport(filter2).subscribe(data => {
        saveAs(data, filter2.filename);
      });

      if (reports.includes(12)) await this.generateReport('boxes', false, true, {
        ...defaults,
        ...getReportOverviewFields('boxes', link, buNames),
        withEnRoute: true,
        reportNum: 12,
      });

    } else if (defaults.reportsmailer === 'reportsMail2') {

      const filter3 = getReportOverviewFields('activityoverview', link, buNames, this.data) as any;

      console.log('filter3', link, buNames, this.data, filter3);

      if (reports.includes(1)) this.api.downloadSalesReport(filter3).subscribe(data => {
        saveAs(data, filter3.filename);
      });

      if (reports.includes(2)) await this.generateReport('offers', true, true, {
        ...defaults,
        ...getReportOverviewFields('offers', link, buNames),
        reportNum: 2,
      });

      if (reports.includes(3)) await this.generateReport('offers', false, true, {
        ...defaults,
        ...getReportOverviewFields('offers', link, buNames),
        extended: 0,
        reportsmailer2: true,
        reportNum: 3,
      });

      if (reports.includes(421)) await this.generateReport('noninvoiced', false, true, {
        ...defaultReport.noninvoiced,
        ...defaults,
        ...getReportOverviewFields('projectoverview', link, buNames, { reportNum: 421}),
        businessUnits: ['EM'].map(m => this.data.businessUnits.find(f => f.code === m)._id),
        filterCompletedProjects: true,
        showRelatedPFSPOs: true,
        showInvoicedOCs: true,
        sortByManager: false,
        filterInternal: true,
        sampleRequest: 2,
        sortType: 3,
        extended: 5,
        special: 1,
        // sortType: 4,       
        dateFrom: -1,
        dateTo: -1,
        reportNum: 421,
        filename: 'SR Report'
      });

    } else if (defaults.reportsmailer === 'reportsMailHQ') {

      console.log('report numbers: ', reports);

      const firstDay = moment().startOf('month').toDate();
      const lastDay = moment().toDate();
      const prevFirst = moment(firstDay).subtract(1, 'month').toDate();
      const prevLast = moment(firstDay).subtract(1, 'day').toDate();

      if (reports.includes(201)) await this.generateReport('dueinvoices', false, true, {
        ...defaults,
        ...getReportOverviewFields('dueinvoices', link, buNames),
        sortByManager: false,
        sampleRequest: 3,
        dateFrom: -1, // moment().add(1, 'month').startOf('month').toDate(),
        dateTo: moment().add(1, 'month').endOf('month').toDate(),
        reportNum: 201,
        filename: 'PaymentReport'
      });

      if (reports.includes(1)) await this.generateReport('dueinvoices', false, true, {
        ...defaults,
        ...getReportOverviewFields('dueinvoices', link, buNames),
        sortByManager: false,
        sampleRequest: 3,
        dateFrom: -1,
        dateTo: -1,
        reportNum: 1,
      });

      if (reports.includes(431)) await this.generateReport('spopayment', false, true, {
        ...defaultReport.spopayment,
        businessUnits: ['VI', 'BA', 'MM', 'AM', 'FX'].map(m => this.data.businessUnits.find(f => f.code === m)._id),
        dateFrom: -1,
        dateTo: -1,
        noncompleteOnly: true,
        variant: 'reportsMailHQ',
        reportNum: 431,
        filename: `${moment().format('YYMMDD')}_SPOIN_wo_TR`,
      });

      if (reports.includes(401)) await this.generateReport('noninvoiced', true, true, {
        ...defaults,
        ...getReportOverviewFields('noninvoiced', link, buNames, { reportNum: 401}),
        businessUnits: ['VI', 'BA', 'MM', 'AM', 'FX'].map(m => this.data.businessUnits.find(f => f.code === m)._id),
        sortByManager: false,
        projectOverview: true,
        filterCompletedProjects: true,
        showRelatedPFSPOs: true,
        showInvoicedOCs: true,
        filterInternal: true, 
        sortType: 4,       
        dateFrom: -1,
        dateTo: -1,
        reportNum: 401,
        filename: 'MonthlyMachinery'
      });

      if (reports.includes(411)) await this.generateReport('projectoverview', false, true, {
        ...defaultReport.noninvoiced,
        ...defaults,
        ...getReportOverviewFields('projectoverview', link, buNames, { reportNum: 411}),
        businessUnits: ['VI', 'BA', 'MM', 'AM', 'FX'].map(m => this.data.businessUnits.find(f => f.code === m)._id),
        sortByManager: false,
        projectOverview: true,
        filterCompletedProjects: true,
        showRelatedPFSPOs: true,
        showInvoicedOCs: true,
        filterInternal: true, 
        sortType: 4,       
        dateFrom: -1,
        dateTo: -1,
        reportNum: 411,
        filename: 'MonthlyMachinery'
      });

      // if (reports.includes(421)) await this.generateReport('noninvoiced', false, true, {
      //   ...defaultReport.noninvoiced,
      //   ...defaults,
      //   ...getReportOverviewFields('projectoverview', link, buNames, { reportNum: 421}),
      //   businessUnits: ['EM'].map(m => this.data.businessUnits.find(f => f.code === m)._id),
      //   filterCompletedProjects: true,
      //   showRelatedPFSPOs: true,
      //   showInvoicedOCs: true,
      //   sortByManager: false,
      //   filterInternal: true,
      //   sampleRequest: 2,
      //   sortType: 3,
      //   extended: 5,
      //   special: 1,
      //   // sortType: 4,       
      //   dateFrom: -1,
      //   dateTo: -1,
      //   reportNum: 421,
      //   filename: 'SR Report'
      // });

      // if (reports.includes(201)) await this.generateReport('dueinvoices', false, true, {
      //   ...defaults,
      //   ...getReportOverviewFields('dueinvoices', link, buNames),
      //   sortByManager: false,
      //   sampleRequest: 3,
      //   dateFrom: -1, // moment().add(1, 'month').startOf('month').toDate(),
      //   dateTo: moment().add(1, 'month').endOf('month').toDate(),
      //   reportNum: 201,
      //   filename: 'PaymentReport'
      // });

    } else if (defaults.reportsmailer === 'inventoryMonthly') {

      console.log('reportsmailer inventory report')
      await this.generateReport('inventory', false, true, {
        ...defaultReport.boxes,
        extended: 11,
      });
    }

  }

  // // sortByManager = false;
  // // quickLinkDateSelection: Date | string = new Date();
  // quickLink_old(link: number) {
  //   const customeroverview = { ...ReportsComponent.defaultReport.customeroverview } as any;
  //   const reportsCopy = { ...ReportsComponent.defaultReport } as any;
  //   customeroverview.showCharts = false;
  //   customeroverview.quickLink = link;

  //   customeroverview.reports = {} as any;
  //   const reports = customeroverview.sort.map(r => ({ name: r, report: JSON.parse(JSON.stringify(reportsCopy[r])) }));
  //   for (const key of customeroverview.sort) {
  //     const rep = JSON.parse(JSON.stringify(reports.find(r => r.name === key).report));
  //     customeroverview.reports[key] = rep;
  //     // console.log('customeroverview', rep, rep.dateFrom, rep.dateTo, customeroverview.reports[key], customeroverview.reports[key].dateFrom, customeroverview.reports[key].dateTo)
  //   }
  //   // for (const i in customeroverview.reports) {
  //   //   customeroverview.reports[i].sortByManager = customeroverview.sortByManager;
  //   // }
  //   for (const i in customeroverview.attachedReports) {
  //     customeroverview.attachedReports[i].showAll = true;
  //   }

  //   // const assignDate = (name, dateSelection, date = new Date()) => {
  //   //   const report = customeroverview.reports[name];
  //   //   this.dateSelectionChanged(report, dateSelection.id, date);
  //   //   // this.dateSelectionChanged(customeroverview, dateSelection.id);
  //   //   console.log('date assigned, result report', name, report.dateFrom, report.dateTo)
  //   // }
  //   customeroverview.reports.dueinvoices.dueStatus = 3 // overdue only

  //   if (!customeroverview.buFilter.all) {
  //     const bu: string[] = [];
  //     if (customeroverview.buFilter.machinery) bu.push('VI', 'MM', 'BA');
  //     if (customeroverview.buFilter.energy) bu.push('EM');
  //     if (customeroverview.buFilter.composite) bu.push('CO');
  //     customeroverview.businessUnits = bu.map(m => this.data.businessUnits.find(f => f.code === m)._id);
  //   }

  //   const today = moment();
  //   const monday = moment().startOf('isoWeek');
  //   const sunday = moment().endOf('isoWeek');
  //   const lastMonday = moment(monday).subtract(1, 'week');
  //   const lastSunday = moment(sunday).subtract(1, 'week');
  //   const nextSunday = moment(sunday).add(1, 'week');
  //   const sundayAfterNext = moment(nextSunday).add(1, 'week');
  //   const firstDay = moment().startOf('month');
  //   const lastDay = moment();
  //   const prevFirst = moment(firstDay).subtract(1, 'month');
  //   const prevLast = moment(firstDay).subtract(1, 'day');

  //   console.log(JSON.stringify({today: today.toDate(), mon: monday.toDate(), sun: sunday.toDate()}));

  //   const assignDate = (name: string, from: moment.Moment, to: moment.Moment) => {
  //     const report = customeroverview.reports[name];
  //     report.dateFrom = from?.toDate();
  //     report.dateTo = to?.toDate();
  //   }

  //   switch (link) {
  //     case 1:
  //       assignDate('lastinvoices', monday, sunday);
  //       assignDate('dueinvoices', null, nextSunday);
  //       assignDate('orders', monday, sunday);
  //       assignDate('noninvoiced', null, sundayAfterNext);
  //       assignDate('srpfin', monday, sunday);
  //       assignDate('srnoninvoiced', monday, sunday);
  //       assignDate('offers', monday, sunday);
  //       break;
  //     case 2:
  //       assignDate('lastinvoices', lastMonday, lastSunday);
  //       assignDate('dueinvoices', null, sunday);
  //       assignDate('orders', lastMonday, lastSunday);
  //       assignDate('noninvoiced', null, nextSunday);
  //       assignDate('srpfin', lastMonday, lastSunday);
  //       assignDate('srnoninvoiced', lastMonday, lastSunday);
  //       assignDate('offers', lastMonday, lastSunday);
  //       break;  
  //     case 3:
  //       assignDate('lastinvoices', firstDay, lastDay);
  //       assignDate('dueinvoices', null, lastDay);
  //       assignDate('orders', firstDay, lastDay);
  //       assignDate('noninvoiced', firstDay, lastDay);
  //       assignDate('srpfin', firstDay, lastDay);
  //       assignDate('srnoninvoiced', firstDay, lastDay);
  //       assignDate('offers', firstDay, lastDay);
  //       break;
  //     case 3:
  //       assignDate('lastinvoices', prevFirst, prevLast);
  //       assignDate('dueinvoices', null, prevLast);
  //       assignDate('orders', prevFirst, prevLast);
  //       assignDate('noninvoiced', prevFirst, prevLast);
  //       assignDate('srpfin', prevFirst, prevLast);
  //       assignDate('srnoninvoiced', prevFirst, prevLast);
  //       assignDate('offers', prevFirst, prevLast);
  //       break;  
  //   }

  //   // switch(link) {
  //   //   case 1:
  //   //     assignDate('lastinvoices', DateSelectionData.thisCalendarWeek);
  //   //     assignDate('dueinvoices', DateSelectionData.allPlus30);
  //   //     assignDate('orders', DateSelectionData.thisCalendarWeek);
  //   //     assignDate('noninvoiced', DateSelectionData.allPlus30);
  //   //     assignDate('srpfin', DateSelectionData.thisCalendarWeek);
  //   //     assignDate('srnoninvoiced', DateSelectionData.allPlus30);
  //   //     assignDate('offers', DateSelectionData.thisCalendarWeek);
  //   //     break;
  //   //   case 2:
  //   //     assignDate('lastinvoices', DateSelectionData.lastCalendarWeek);
  //   //     assignDate('dueinvoices', DateSelectionData.allPlus30);
  //   //     assignDate('orders', DateSelectionData.lastCalendarWeek);
  //   //     assignDate('noninvoiced', DateSelectionData.allPlus30);
  //   //     assignDate('srpfin', DateSelectionData.lastCalendarWeek);
  //   //     assignDate('srnoninvoiced', DateSelectionData.allPlus30);
  //   //     assignDate('offers', DateSelectionData.lastCalendarWeek);
  //   //     break;
  //   //   case 3:
  //   //     assignDate('lastinvoices', DateSelectionData.currentMonth);
  //   //     assignDate('dueinvoices', DateSelectionData.allPlus30);
  //   //     assignDate('orders', DateSelectionData.currentMonth);
  //   //     assignDate('noninvoiced', DateSelectionData.allPlus30);
  //   //     assignDate('srpfin', DateSelectionData.currentMonth);
  //   //     assignDate('srnoninvoiced', DateSelectionData.allPlus30);
  //   //     assignDate('offers', DateSelectionData.currentMonth);
  //   //     break;
  //   //   case 4:
  //   //     assignDate('lastinvoices', DateSelectionData.lastMonth);
  //   //     assignDate('dueinvoices', DateSelectionData.lastMonth);
  //   //     assignDate('orders', DateSelectionData.lastMonth);
  //   //     assignDate('noninvoiced', DateSelectionData.lastMonth);
  //   //     assignDate('srpfin', DateSelectionData.lastMonth);
  //   //     assignDate('srnoninvoiced', DateSelectionData.lastMonth);
  //   //     assignDate('offers', DateSelectionData.lastMonth);
  //   //     break;
  //   //   case 5:
  //   //     assignDate('lastinvoices', DateSelectionData.thisCalendarWeek, startDate);
  //   //     assignDate('dueinvoices', DateSelectionData.allPlus30, startDate);
  //   //     assignDate('orders', DateSelectionData.thisCalendarWeek, startDate);
  //   //     assignDate('noninvoiced', DateSelectionData.allPlus30, startDate);
  //   //     assignDate('srpfin', DateSelectionData.thisCalendarWeek, startDate);
  //   //     assignDate('srnoninvoiced', DateSelectionData.allPlus30, startDate);
  //   //     assignDate('offers', DateSelectionData.thisCalendarWeek, startDate);
  //   //     break;
  //   //   case 6:
  //   //     assignDate('lastinvoices', DateSelectionData.lastCalendarWeek, startDate);
  //   //     assignDate('dueinvoices', DateSelectionData.allPlus30, startDate);
  //   //     assignDate('orders', DateSelectionData.lastCalendarWeek, startDate);
  //   //     assignDate('noninvoiced', DateSelectionData.allPlus30, startDate);
  //   //     assignDate('srpfin', DateSelectionData.lastCalendarWeek, startDate);
  //   //     assignDate('srnoninvoiced', DateSelectionData.allPlus30, startDate);
  //   //     assignDate('offers', DateSelectionData.lastCalendarWeek, startDate);
  //   //     break;
  //   //   case 7:
  //   //     assignDate('lastinvoices', DateSelectionData.currentMonth, startDate);
  //   //     assignDate('dueinvoices', DateSelectionData.allPlus30, startDate);
  //   //     assignDate('orders', DateSelectionData.currentMonth, startDate);
  //   //     assignDate('noninvoiced', DateSelectionData.allPlus30, startDate);
  //   //     assignDate('srpfin', DateSelectionData.currentMonth, startDate);
  //   //     assignDate('srnoninvoiced', DateSelectionData.allPlus30, startDate);
  //   //     assignDate('offers', DateSelectionData.currentMonth, startDate);
  //   //     break;
  //   //   case 8:
  //   //     assignDate('lastinvoices', DateSelectionData.lastMonth, startDate);
  //   //     assignDate('dueinvoices', DateSelectionData.lastMonth, startDate);
  //   //     assignDate('orders', DateSelectionData.lastMonth, startDate);
  //   //     assignDate('noninvoiced', DateSelectionData.lastMonth, startDate);
  //   //     assignDate('srpfin', DateSelectionData.lastMonth, startDate);
  //   //     assignDate('srnoninvoiced', DateSelectionData.lastMonth, startDate);
  //   //     assignDate('offers', DateSelectionData.lastMonth, startDate);
  //   //     break;  
  //   //   // case 5:
  //   //   //   assignDate('lastinvoices', DateSelectionData.thisCalendarWeek);
  //   //   //   assignDate('dueinvoices', DateSelectionData.thisCalendarWeek);
  //   //   //   assignDate('orders', DateSelectionData.thisCalendarWeek);
  //   //   //   assignDate('noninvoiced', DateSelectionData.thisCalendarWeek);
  //   //   //   assignDate('srpfin', DateSelectionData.thisCalendarWeek);
  //   //   //   assignDate('srnoninvoiced', DateSelectionData.thisCalendarWeek);
  //   //   //   assignDate('offers', DateSelectionData.thisCalendarWeek);
  //   //   // case 6:
  //   //   //   assignDate('lastinvoices', DateSelectionData.lastCalendarWeek);
  //   //   //   assignDate('dueinvoices', DateSelectionData.lastCalendarWeek);
  //   //   //   assignDate('orders', DateSelectionData.lastCalendarWeek);
  //   //   //   assignDate('noninvoiced', DateSelectionData.lastCalendarWeek);
  //   //   //   assignDate('srpfin', DateSelectionData.lastCalendarWeek);
  //   //   //   assignDate('srnoninvoiced', DateSelectionData.lastCalendarWeek);
  //   //   //   assignDate('offers', DateSelectionData.lastCalendarWeek);
  //   //   //   break;
  //   //   // case 7:
  //   //   //   assignDate('lastinvoices', DateSelectionData.currentMonth);
  //   //   //   assignDate('dueinvoices', DateSelectionData.currentMonth);
  //   //   //   assignDate('orders', DateSelectionData.currentMonth);
  //   //   //   assignDate('noninvoiced', DateSelectionData.currentMonth);
  //   //   //   assignDate('srpfin', DateSelectionData.currentMonth);
  //   //   //   assignDate('srnoninvoiced', DateSelectionData.currentMonth);
  //   //   //   assignDate('offers', DateSelectionData.currentMonth);
  //   //   //   break;
  //   //   // case 8:
  //   //   //   assignDate('lastinvoices', DateSelectionData.lastMonth);
  //   //   //   assignDate('dueinvoices', DateSelectionData.allPlus30);
  //   //   //   assignDate('orders', DateSelectionData.lastMonth);
  //   //   //   assignDate('noninvoiced', DateSelectionData.allPlus30);
  //   //   //   assignDate('srpfin', DateSelectionData.lastMonth);
  //   //   //   assignDate('srnoninvoiced', DateSelectionData.allPlus30);
  //   //   //   assignDate('offers', DateSelectionData.lastMonth);
  //   //   //   break;
  //   //   case 10:
  //   //     customeroverview.businessUnits = this.data.businessUnits.filter(f => ['VI', 'MM', 'BA'].includes(f.code)).map(m => mongoId(m));
  //   //   case 11:
  //   //     if (link == 11) customeroverview.businessUnits = this.data.businessUnits.filter(f => ['EM'].includes(f.code)).map(m => mongoId(m));
  //   //   case 12:
  //   //     if (link == 12) customeroverview.businessUnits = this.data.businessUnits.filter(f => ['CO'].includes(f.code)).map(m => mongoId(m));
  //   //     assignDate('lastinvoices', DateSelectionData.thisCalendarWeek);
  //   //     assignDate('dueinvoices', DateSelectionData.all);
  //   //     assignDate('orders', DateSelectionData.thisCalendarWeek);
  //   //     assignDate('noninvoiced', DateSelectionData.nextCalendarWeek);
  //   //     assignDate('offers', DateSelectionData.lastCalendarWeek);
  //   //     delete customeroverview.attachedReports.srpfin;
  //   //     delete customeroverview.attachedReports.srnoninvoiced;
  //   //     customeroverview.reports.dueinvoices.dueStatus = 3 // overdue only
  //   //     break;
  //   // }
    
  //   customeroverview.dateFrom = null;
  //   customeroverview.dateTo = null;
  //   this.onTogglePrinter('customeroverview', customeroverview);

  //   console.log('customeroverview', customeroverview);
  // }

  toggleShowAllReports() {
    const show = (Object.values(this.report.customeroverview.attachedReports)[0] as any).showAll ? false : true;
    console.log('show', show)
    for (const rep in this.report.customeroverview.attachedReports) {
      this.report.customeroverview.attachedReports[rep].showAll = show;
      console.log('show2',this.report.customeroverview)
    }
  }

  openReferrerDocument() {
    this.router.navigate(
      ['/pages/erp/document/nrka'],
      { queryParams: { code: this.jsonParams?.combinedShipment } }
    );
  }

}

// defaultReport.srpfin = { ...defaultReport.lastinvoices }
// defaultReport.srpfin.sampleRequest = 2 // sr only
// defaultReport.srnoninvoiced = { ...defaultReport.noninvoiced }
// defaultReport.srnoninvoiced.sampleRequest = 2 // sr only

